import auth from '@/mixins/auth.js'
import { AuthErrorCodes } from '@/helpers/authErrorCodes'

export default function(error) {
  if ((error.response || {}).status === 403 && auth.isAuthenticated()) {
    auth.logout()

    if (error.response.data.code === AuthErrorCodes.SSORedirect) {
      window.location = `/login?code=${AuthErrorCodes.SSORedirect}`
      return
    }

    if (error.response.data.code === AuthErrorCodes.PasswordExpired) {
      window.location = `/login/password?code=${AuthErrorCodes.PasswordExpired}`
      return
    }

    window.location = '/login'
  }

  return error
}
